import { UText } from "@/ui-component"
import { Grid } from "@mui/material"
import { useTranslation } from "react-i18next"
import { DigitalFill } from "./components/DigitalFill"
import { StageNumber } from "./components/StageNumber"
import { useAppSelector } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"
import { useCallback, useEffect, useRef } from "react"
import { useClinicalSettingsUpdate } from "@/hooks/useClinicalSettingsUpdate"
import { updateLuxCreo } from "@/core/app/slices/user/userSlice"

const LuxCreo = () => {
  const { t } = useTranslation()
  const {
    clinicalSettings: { LuxcreoModel },
  } = useAppSelector((state: RootState) => state.userService)
  const onPrintSettingChange = useClinicalSettingsUpdate()
  const prevLuxcreoModel = useRef(LuxcreoModel)

  // Setup update function
  const updateClinicalSettingsAPI = useCallback(
    (updates: any) => {
      const updatedData = {
        LuxcreoModel: {
          ...updates,
        },
      }
      onPrintSettingChange(updatedData)
    },
    [onPrintSettingChange],
  )

  useEffect(() => {
    // Compare current with previous value using deep comparison
    const currentStr = JSON.stringify(LuxcreoModel)
    const prevStr = JSON.stringify(prevLuxcreoModel.current)
    
    if (prevStr !== currentStr) {
      // Only call API if we have a meaningful previous value (skip initial load)
      if (prevLuxcreoModel.current && Object.keys(prevLuxcreoModel.current).length > 0) {
        updateClinicalSettingsAPI(LuxcreoModel)
      }
      // Update previous value for next comparison
      prevLuxcreoModel.current = LuxcreoModel
    }
  }, [LuxcreoModel, updateClinicalSettingsAPI])

  return (
    <Grid>
      <Grid>
        <UText variant={"h6"} sxProp={{ color: "#000000" }}>
          {t("stlPrinting.stageNumbertitle")}
        </UText>
        <Grid
          item
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "start",
            p: 3,
            gap: 3,
          }}
        >
          <StageNumber
            currPrint={LuxcreoModel}
            updateModel={updateLuxCreo}
          />
        </Grid>
      </Grid>
      <Grid>
        <UText variant={"h6"} sxProp={{ color: "#000000" }}>
          {t("stlPrinting.digitalFill")}
        </UText>
        <Grid
          item
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "start",
            p: 3,
            gap: 3,
          }}
        >
          <DigitalFill
            currPrint={LuxcreoModel}
            updateModel={updateLuxCreo}
          />
        </Grid>
      </Grid>
    </Grid>
  )
}

export default LuxCreo
